import type { RequestFn } from '../http'

export interface BackupMeta {
  fileName: string
  sizeBytes: number
  createdAt: string
  durationMs: number
  note: string
  source: 'manual' | 'scheduled'
}

export interface BackupConfig {
  enabled: boolean
  frequency: 'hourly' | 'daily' | 'weekly'
  hour: number
  weekday: number
  retentionDays: number
  hourlyRetentionDays: number
  dailyRetentionDays: number
  weeklyRetentionDays: number
  monthlyRetentionDays: number
  /** Harte Obergrenze für die Gesamtgröße aller Dumps in GB; 0 = aus. */
  maxTotalSizeGB: number
}

export function createBackupApi(request: RequestFn) {
  return {
    async listBackups() {
      return request<{ backups: BackupMeta[] }>('/backup/list')
    },

    async getBackupSettings() {
      return request<BackupConfig>('/backup/settings')
    },

    async saveBackupSettings(config: BackupConfig) {
      return request<{ success: boolean }>('/backup/settings', {
        method: 'POST',
        body: JSON.stringify(config),
      })
    },

    async createBackup() {
      return request<BackupMeta>('/backup/create', {
        method: 'POST',
        body: '{}',
      })
    },

    async restoreBackup(fileName: string, password?: string) {
      return request<{ success: boolean }>('/backup/restore', {
        method: 'POST',
        body: JSON.stringify({ fileName, confirm: 'RESTORE', ...(password ? { password } : {}) }),
      })
    },

    async deleteBackup(fileName: string) {
      return request<{ success: boolean }>('/backup/delete', {
        method: 'POST',
        body: JSON.stringify({ fileName }),
      })
    },

    backupDownloadUrl(fileName: string): string {
      return `/api/backup/download/${encodeURIComponent(fileName)}`
    },
  }
}
